import { InitialState } from '@libs/focus-frontend-types/src/@teamleader/api/initialState';

const mapTLGLOBALS = (initialState: InitialState) => {
  return {
    GOOGLE_API_KEY: initialState.config.googleKey,
    WEB_MANIFEST: initialState.config.webManifestUrl,
    SAASQUATCH_TENANT_KEY: environment.SAASQUATCH_TENANT_KEY,
    UN: initialState.user.email,
    LANGUAGE: initialState.user.language,
    LANGUAGE_WITHOUT_LOCALIZATION: initialState.user.languageWithoutLocalization,
    LOCALE: initialState.user.locale,
    SAASQUATCH_LOCALE: initialState.user.saasquatchLocale,
    ADMIN: initialState.user.isAdmin,
    EMAIL: initialState.user.email,
    NAME: initialState.user.name,
    FIRST_NAME: initialState.user.firstName,
    LAST_NAME: initialState.user.lastName || '',
    UUID: initialState.user.uuid,
    EMPLOYEEID: initialState.user.intId.toString(),
    IS_DEMO_ACCOUNT: initialState.account.isDemo,
    TLOFFICE: initialState.account.teamleaderOffice,
    MAX_AMOUNT_OF_EMPLOYEES: initialState.account.maxAmountOfEmployees,
    ACTIVATION_TIMESTAMP: initialState.account.activationTimestamp.toString(),
    ACCOUNTID: initialState.account.intId.toString(),
    MONTHLY_REVENUE: initialState.account.monthlyRevenue.toString(),
    ACCOUNT_STATUS: initialState.account.status,
    IMPERSONATING: initialState.user.isImpersonating,
    TWILIO_CAPABILITY_TOKEN: initialState.config.twilioCapabilityToken,
    TWILIO_STATUS: initialState.config.twilioStatus,
  };
};

export default mapTLGLOBALS;
